/**
 * Modal — shadcn Dialog 어댑터
 *
 * 기존 @/ui Modal API(open/onClose/title/headerExtra/size)를 유지하며
 * 내부는 shadcn Dialog로 위임한다. ESC·백드롭 닫기·스크롤 잠금은 Dialog 기본 제공.
 */
import { ReactNode } from 'react'
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { cn } from './cn'

interface ModalProps {
  open: boolean
  onClose: () => void
  title?: string
  headerExtra?: ReactNode
  size?: 'sm' | 'md' | 'lg' | 'xl'
  className?: string
  children: ReactNode
}

const SIZE_CLASS = {
  sm: 'sm:max-w-sm',
  md: 'sm:max-w-lg',
  lg: 'sm:max-w-2xl',
  xl: 'sm:max-w-4xl',
} as const

export function Modal({
  open,
  onClose,
  title,
  headerExtra,
  size = 'md',
  className,
  children,
}: ModalProps) {
  return (
    <Dialog open={open} onOpenChange={(next) => { if (!next) onClose() }}>
      <DialogContent className={cn(SIZE_CLASS[size], className)}>
        {(title || headerExtra) && (
          <DialogHeader>
            {title && <DialogTitle>{title}</DialogTitle>}
            {headerExtra}
          </DialogHeader>
        )}
        {children}
      </DialogContent>
    </Dialog>
  )
}
